module.exports = __webpack_public_path__ + "NH_logo-80c291ab16972885178e.png";